import {
  primaryColor, primaryHeadingColor,
  wMedium, secondaryFont,
  extendedSearchLoader,
  maxWidth,
  retina,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';

const StyleWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
height: inherit;
width: 200px;
.main{
    background:white;
    border:1px solid ${primaryColor};
    padding: 12px 15px;
    text-align: center;
    border-radius:16px;
    margin:0 18px;
    .loader-style{
      height: 90px;
      width: 90px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: 70px;
        width: 70px;
      }
    }
    .text{
      font-size: 16px;
      color:${primaryHeadingColor};
      font-weight: ${wMedium};
      font-family: ${secondaryFont};
      letter-spacing: -0.45px;
      line-height: 20px;
      margin-top: 20px;
      margin-bottom: 5px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        font-size: 14px;
      }
    }
  }
`;

const ExtendedSearchLoader = function ExtendedSearchLoader() {
  return (
    <StyleWrapper className="extended-search-loader-wrapper">
      <div className="main">
        <img className="loader-style" src={extendedSearchLoader} alt="extended-loader" />
        <p className="text">
          {
            'Uncovering more People using xiQ\'s extended Search.'
          }

        </p>
      </div>
    </StyleWrapper>
  );
};
export default ExtendedSearchLoader;
